// --------------------------------------------------------------------------
// #237 Credit Card Type - Validation to check whether card type is accepted
//                         (Taken from the original Membership form js)
// --------------------------------------------------------------------------
// Author:      Zone
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var events = require('common-js-pub-sub')();

// jquery plugins
require('../plugins/jquery.validate');
require('../plugins/jquery.validate.unobtrusive');

module.exports = function (options) {
	var context = options.context;

	/*
 * Returns the type fo the credit card as a user types
 * @param  { int } cardNumber - the number of the credit card that the user has entered
 * @return { String } results - the name of the credit card provider or unknown if nothing is found
 */
	function getCreditCardType(cardNumber) {
		var result = 'unknown';
		// check for MasterCard
		if (/^5[1-5]/.test(cardNumber)) {
			result = 'mastercard';
		}
		// check for Visa
		else if (/^4/.test(cardNumber)) {
				result = 'visa';
			}
			// check for Solo
			else if (/^6334|6767$/.test(cardNumber)) {
					result = 'solo';
				}
		return result;
	}

	events.subscribe('custom-error', function (options) {
		var element = options.element;
		var message = options.message;
		var errorSpan = element.siblings('[class*="field-validation"]');
		errorSpan.removeClass('field-validation-valid').addClass('field-validation-error').text(message);
	});

	events.subscribe('remove-custom-error', function (options) {
		var element = options.element;
		var errorSpan = element.siblings('[class*="field-validation"]');
		errorSpan.removeClass('field-validation-error').addClass('field-validation-valid').empty();
	});

	function init() {

		context.on({
			keyup: function keyup() {
				var cardType = getCreditCardType(this.value);
				var cardTypeWrapper = $('[data-name="credit-card-types"]');

				if (cardType !== 'unknown') {
					cardTypeWrapper.children().addClass('inactive');

					if (cardType === 'visa') {
						cardTypeWrapper.find('.icon-visa').removeClass('inactive');
					} else if (cardType === 'mastercard') {
						cardTypeWrapper.find('.icon-mastercard').removeClass('inactive');
					} else if (cardType === 'solo') {
						cardTypeWrapper.find('.icon-solo').removeClass('inactive');
					}
				} else {
					cardTypeWrapper.children().addClass('inactive');
				}
			},
			blur: function blur() {
				var cardType = getCreditCardType(this.value);

				if (cardType === 'unknown') {
					events.publish('custom-error', {
						element: $(this),
						message: 'Sorry - we don\'t accept this type of card.'
					});
				} else {
					events.publish('remove-custom-error', {
						element: $(this)
					});
				}
			}
		}, '[data-binding="card-type"]');
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/card-type.js
// module id = 276
// module chunks = 0